import { Navigate, Route, Routes } from "react-router-dom";

import MaintenanceControl from "./maintenanceControl";
import Monitoring from "../../../components/monitoring";
import LegacyMonitoring from "./monitoring";
import { NewUiGate } from "../../../features/newUi";
import DealershipAppointmentsRoutes from "./appointments/routes";
import MaintenanceMonitoring from "./maintenanceMonitoring";
import ServiceBayControl from "./serviceBayControl";
import BudgetsV2Page from "./budgets";
import { FeatureFlag } from "../../../components/FeatureFlag";
import SupportPage from "../../../components/support";
import SupportDetailsPage from "../../../components/support/pages/details";
import NewSupportCallPage from "../../../components/support/newSupportCall";

const DealershipRoutes = (props: any) => (
  <Routes>
    <Route
      path="/"
      element={<Navigate to="/dealership/maintenance-control" />}
    />
    <Route
      path="/monitoring"
      element={<NewUiGate legacy={<LegacyMonitoring {...props} />} next={<Monitoring persona="CONSULTANT" />} />}
    />
    <Route path="/maintenance-control" element={<MaintenanceControl {...props} />} />
    <Route path="/maintenance-monitoring" index element={<MaintenanceMonitoring {...props} />} />
    <Route
      path="/appointments/*"
      index
      element={<DealershipAppointmentsRoutes {...props} />}
    />
    <Route path="/service-bay-control" index element={<ServiceBayControl {...props} />} />
    <Route path="/budgets/*" element={<FeatureFlag name="budget.consultant"><BudgetsV2Page {...props} /></FeatureFlag>} />
    <Route path="/budgets-kanban/*" element={<FeatureFlag name="budget.consultant"><BudgetsV2Page {...props} /></FeatureFlag>} />
    <Route path="/support" element={<SupportPage {...props} />} />
    <Route path="/support/new-support-call" element={<NewSupportCallPage {...props} />} />
    <Route path="/support/details" element={<SupportDetailsPage {...props} />} />
  </Routes>
);

export default DealershipRoutes;
